// extracted by mini-css-extract-plugin
module.exports = {"icon-item":"_2L5av","qt-logo":"_2Iq0I"};